import React from "react";
import { Typography, Box, Container } from "@material-ui/core";

const About = () => {
  return (
    <Box marginTop="2rem">
      <Container justifyContent="center">
        <Typography variant="h4" color="secondary" align="center">
          About This App
        </Typography>
        <Typography variant="body1" align="center">
          App to search Github users
        </Typography>
        <Typography variant="body1" align="center">
          Version 1.6.0
        </Typography>
      </Container>
    </Box>
  );
};

export default About;
